export type RegionLabelLocale = "de" | "en";

const LANGUAGE_STORAGE_KEY = "language";

const normalizeLocale = (raw: unknown): RegionLabelLocale => {
  if (typeof raw !== "string") {
    return "de";
  }
  return raw.trim().toLowerCase().startsWith("en") ? "en" : "de";
};

const readPreferredLocale = (): RegionLabelLocale => {
  if (typeof window === "undefined") {
    return "de";
  }
  try {
    return normalizeLocale(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
  } catch {
    return "de";
  }
};

export const formatRegionLabel = (
  name: string | null | undefined,
  nameEn?: string | null,
  locale?: RegionLabelLocale | string | null
): string => {
  const de = (name ?? "").trim();
  const en = (nameEn ?? "").trim();
  const effectiveLocale = normalizeLocale(locale ?? readPreferredLocale());

  if (effectiveLocale === "en") {
    return en || de;
  }
  return de || en;
};

export const formatRegionPath = (
  pathDe: Array<string | null | undefined> | null | undefined,
  pathEn?: Array<string | null | undefined> | null,
  locale?: RegionLabelLocale | string | null
): string[] => {
  const deList = Array.isArray(pathDe) ? pathDe : [];
  const enList = Array.isArray(pathEn) ? pathEn : [];
  return deList
    .map((name, index) =>
      formatRegionLabel(name ?? "", enList[index] ?? null, locale)
    )
    .filter((entry) => entry.trim().length > 0);
};
